import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Layout } from "@/components/layout/Layout";
import GAListener from "@/components/common/GAListener";
import Home from "@/pages/Home";
import { ServicesIndex, ServiceDetail } from "@/pages/services/ServicePages";
import { SolutionsIndex, IndustryDetail } from "@/pages/solutions/SolutionsPages";
import EngagementModels from "@/pages/EngagementModels";
import { Products, ProductDetail } from "@/pages/products/ProductPages";
import { SuccessStories, SuccessStoryDetail } from "@/pages/successStories/SuccessPages";
import { Blog, BlogDetail } from "@/pages/blog/BlogPages";
import CostExplorer from "@/pages/CostExplorer";
import RequestQuote from "@/pages/RequestQuote";
import ScheduleMeeting from "@/pages/ScheduleMeeting";
import Contact from "@/pages/Contact";
import Search from "@/pages/Search";
import NotFound from "@/pages/NotFound";
import AdminRouter from "@/pages/admin/AdminRouter";

function PublicShell({ children }) {
    return <Layout>{children}</Layout>;
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <GAListener />
                <Routes>
                    {/* Admin lives outside the public shell */}
                    <Route path="/admin/*" element={<AdminRouter />} />

                    {/* Public site */}
                    <Route path="/" element={<PublicShell><Home /></PublicShell>} />
                    <Route path="/what-we-do" element={<PublicShell><ServicesIndex /></PublicShell>} />
                    <Route path="/what-we-do/:slug" element={<PublicShell><ServiceDetail /></PublicShell>} />
                    <Route path="/solutions" element={<PublicShell><SolutionsIndex /></PublicShell>} />
                    <Route path="/solutions/:slug" element={<PublicShell><IndustryDetail /></PublicShell>} />
                    <Route path="/engagement-models" element={<PublicShell><EngagementModels /></PublicShell>} />
                    <Route path="/products" element={<PublicShell><Products /></PublicShell>} />
                    <Route path="/products/:id" element={<PublicShell><ProductDetail /></PublicShell>} />
                    <Route path="/success-stories" element={<PublicShell><SuccessStories /></PublicShell>} />
                    <Route path="/success-stories/:id" element={<PublicShell><SuccessStoryDetail /></PublicShell>} />
                    <Route path="/blog" element={<PublicShell><Blog /></PublicShell>} />
                    <Route path="/blog/:id" element={<PublicShell><BlogDetail /></PublicShell>} />
                    <Route path="/cost-explorer" element={<PublicShell><CostExplorer /></PublicShell>} />
                    <Route path="/request-quote" element={<PublicShell><RequestQuote /></PublicShell>} />
                    <Route path="/schedule-meeting" element={<PublicShell><ScheduleMeeting /></PublicShell>} />
                    <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
                    <Route path="/search" element={<PublicShell><Search /></PublicShell>} />
                    <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}
